import styled from 'styled-components'

import UnstyledLink from 'components/Link'

export const Link = styled(UnstyledLink)`
  display: block;
  margin-top: 24px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.small};
`

export const FormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
`
